import { useMemo } from 'react';

/**
 * Check if multiple pieces of data are ready (not undefined or null).
 *
 * @param {Array} deps - array of values to check
 * @returns {boolean} - true if all are non-null and non-undefined
 */
export function useReady(deps) {
  return useMemo(() => {
    return deps.every((dep) => dep !== undefined && dep !== null);
  }, [deps]);
}
